// extracted by mini-css-extract-plugin
export default {"loader_container":"MediumLoader_loader_container__gd0yJ","loader":"MediumLoader_loader__4AGZ4","spinner-c7wet2":"MediumLoader_spinner-c7wet2__aj7Hm"};